import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-dropdown-options-modal',
  templateUrl: './dropdown-options-modal.component.html',
  styleUrls: ['./dropdown-options-modal.component.scss'],
  standalone: false
})
export class DropdownOptionsModalComponent implements OnInit {
  form: FormGroup;
  initialOptions: Array<{ value: any; label: string; isDefault?: boolean }> = [];

  constructor(
    private fb: FormBuilder,
    private modal: NzModalRef
  ) {
    this.form = this.fb.group({
      options: this.fb.array([])
    });
  }

  ngOnInit(): void {
    // Popula com opções existentes ou adiciona uma linha vazia
    if (this.initialOptions && this.initialOptions.length > 0) {
      this.initialOptions.forEach(opt => {
        this.addOption(opt.value, opt.label, opt.isDefault || false);
      });
    } else {
      this.addOption('', '', false);
    }
  }

  get optionsArray(): FormArray {
    return this.form.get('options') as FormArray;
  }

  addOption(value: string = '', label: string = '', isDefault: boolean = false): void {
    const optionGroup = this.fb.group({
      value: [value, Validators.required],
      label: [label, Validators.required],
      isDefault: [isDefault]
    });
    this.optionsArray.push(optionGroup);
  }

  // Ao marcar uma opção como padrão, desmarca todas as outras
  onDefaultChange(index: number): void {
    const currentValue = this.optionsArray.at(index).get('isDefault')?.value;
    if (currentValue) {
      // Desmarca todas as outras opções
      this.optionsArray.controls.forEach((control, i) => {
        if (i !== index) {
          control.get('isDefault')?.setValue(false, { emitEvent: false });
        }
      });
    }
  }

  removeOption(index: number): void {
    this.optionsArray.removeAt(index);
    
    // Se remover todas, adiciona uma linha vazia
    if (this.optionsArray.length === 0) {
      this.addOption('', '', false);
    }
  }

  handleOk(): void {
    if (this.form.valid) {
      const options = this.optionsArray.value
        .filter((opt: any) => opt.value !== '' || opt.label !== '')
        .map((opt: any) => ({
          value: opt.value,
          label: opt.label,
          isDefault: opt.isDefault || false
        }));
      this.modal.close(options);
    } else {
      // Marca todos os campos como touched para mostrar erros
      Object.values(this.optionsArray.controls).forEach(control => {
        Object.values((control as FormGroup).controls).forEach(field => {
          field.markAsTouched();
          field.updateValueAndValidity();
        });
      });
    }
  }

  handleCancel(): void {
    this.modal.close();
  }

  trackByIndex(index: number): number {
    return index;
  }
}
